function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__a",
  x1: 510.67,
  x2: 1260.52,
  y1: 802,
  y2: 802,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#cce0f4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.06,
  stopColor: "#c3dcf2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.17,
  stopColor: "#a9d2ee"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.31,
  stopColor: "#80c2e7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46,
  stopColor: "#47acde"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.57,
  stopColor: "#1e9cd7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#0075be"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#005b97"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__b",
  x1: 0,
  x2: 1005.45,
  y1: 931.18,
  y2: 931.18,
  xlinkHref: "#logo_svg__a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__c",
  x1: 255.06,
  x2: 1006.77,
  y1: 506.02,
  y2: 506.02,
  xlinkHref: "#logo_svg__a"
}));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__a)",
  d: "M510.67 562.09l120.78-66.32 454.3 261.45-.53 233.75-374.74 215.04 175.7 102.58 373.35-214.68.99-437.48-628.71-361.01-120.69 66.61-.45 200.06z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__b)",
  d: "M831.14 697.91l-.33 146.24-452.89 262.63-203.15-117.51.98-434.36L.98 654.44 0 1087.58l376.41 219.86 628.72-360.89.32-144.46-174.31-104.18z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__c)",
  d: "M1006.31 420.79L630.98 200.68 431.04 309.83l-1.22 538.14 121.54 65.97-165.06 98.1-131.24-67.18 1.65-729.42L632.07 0l374.7 218.23-.46 202.56z"
});

function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 1260.52 1308.59"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2aWV3Qm94PSIwIDAgMTI2MC41MiAxMzA4LjU5Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6dXJsKCNTa3kpO30uY2xzLTJ7ZmlsbDp1cmwoI1NreS0yKTt9LmNscy0ze2ZpbGw6dXJsKCNTa3ktMyk7fTwvc3R5bGU+PGxpbmVhckdyYWRpZW50IGlkPSJTa3kiIHgxPSI1MTAuNjciIHkxPSI4MDIiIHgyPSIxMjYwLjUyIiB5Mj0iODAyIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjY2NlMGY0Ii8+PHN0b3Agb2Zmc2V0PSIwLjA2IiBzdG9wLWNvbG9yPSIjYzNkY2YyIi8+PHN0b3Agb2Zmc2V0PSIwLjE3IiBzdG9wLWNvbG9yPSIjYTlkMmVlIi8+PHN0b3Agb2Zmc2V0PSIwLjMxIiBzdG9wLWNvbG9yPSIjODBjMmU3Ii8+PHN0b3Agb2Zmc2V0PSIwLjQ2IiBzdG9wLWNvbG9yPSIjNDdhY2RlIi8+PHN0b3Agb2Zmc2V0PSIwLjU3IiBzdG9wLWNvbG9yPSIjMWU5Y2Q3Ii8+PHN0b3Agb2Zmc2V0PSIwLjg3IiBzdG9wLWNvbG9yPSIjMDA3NWJlIi8+PHN0b3Agb2Zmc2V0PSIwLjk5IiBzdG9wLWNvbG9yPSIjMDA1Yjk3Ii8+PC9saW5lYXJHcmFkaWVudD48bGluZWFyR3JhZGllbnQgaWQ9IlNreS0yIiB4MT0iMCIgeTE9IjkzMS4xOCIgeDI9IjEwMDUuNDUiIHkyPSI5MzEuMTgiIHhsaW5rOmhyZWY9IiNTa3kiLz48bGluZWFyR3JhZGllbnQgaWQ9IlNreS0zIiB4MT0iMjU1LjA2IiB5MT0iNTA2LjAyIiB4Mj0iMTAwNi43NyIgeTI9IjUwNi4wMiIgeGxpbms6aHJlZj0iI1NreSIvPjwvZGVmcz48cG9seWdvbiBjbGFzcz0iY2xzLTEiIHBvaW50cz0iNTEwLjY3IDU2Mi4wOSA2MzEuNDUgNDk1Ljc3IDEwODUuNzUgNzU3LjIyIDEwODUuMjIgOTkwLjk3IDcxMC40OCAxMjA2LjAxIDg4Ni4xOCAxMzA4LjU5IDEyNTkuNTMgMTA5My45MSAxMjYwLjUyIDY1Ni40MyA2MzEuODEgMjk1LjQyIDUxMS4xMiAzNjIuMDMgNTEwLjY3IDU2Mi4wOSIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMiIgcG9pbnRzPSI4MzEuMTQgNjk3LjkxIDgzMC44MSA4NDQuMTUgMzc3LjkyIDExMDYuNzggMTc0Ljc3IDk4OS4yNyAxNzUuNzUgNTU0LjkxIDAuOTggNjU0LjQ0IDAgMTA4Ny41OCAzNzYuNDEgMTMwNy40NCAxMDA1LjEzIDk0Ni41NSAxMDA1LjQ1IDgwMi4wOSA4MzEuMTQgNjk3LjkxIi8+PHBvbHlnb24gY2xhc3M9ImNscy0zIiBwb2ludHM9IjEwMDYuMzEgNDIwLjc5IDYzMC45OCAyMDAuNjggNDMxLjA0IDMwOS44MyA0MjkuODIgODQ3Ljk3IDU1MS4zNiA5MTMuOTQgMzg2LjMgMTAxMi4wNCAyNTUuMDYgOTQ0Ljg2IDI1Ni43MSAyMTUuNDQgNjMyLjA3IDAgMTAwNi43NyAyMTguMjMgMTAwNi4zMSA0MjAuNzkiLz48L3N2Zz4=";
export { SvgLogo as ReactComponent };